<script lang='ts'>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'MsSvgIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: '#121432',
    },
  },
  setup(props) {
    const iconName = computed(() => {
      return `#icon-${props.icon}`
    })
    const style = computed(() => {
      return {
        width: `${props.size}px`,
        height: `${props.size}px`,
        color: props.color,
      }
    })
    return {
      style,
      iconName,
    }
  },
})
</script>

<template>
  <svg :style="style" aria-hidden="true" class="svg-icon">
    <use :fill="color" :xlink:href="iconName" />
  </svg>
</template>

<style lang='scss' scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
